function convertUnits(units, node) {
  window.unitsConv.switchSpans(units, node);
  window.unitsConv.switchSvgIcons(units, node);
}

function addHook(object, propertyName, cb) {
  /* eslint-disable no-param-reassign */
  object[`__${propertyName}`] = object[propertyName];
  Object.defineProperty(object, propertyName, {
    get() {
      return object[`__${propertyName}`];
    },
    set(newValue) {
      cb(newValue);
      object[`__${propertyName}`] = newValue;
    },
  });
  /* eslint-enable no-param-reassign */
}

function SwitchUnitsPlugin($pool) {
  let { currentUnits = 'm' } = window.unitsConv;

  addHook(window.unitsConv, 'currentUnits', newValue => {
    currentUnits = newValue;
  });

  return function run(eventName, payload) {
    if (currentUnits === 'm') return;

    if (eventName === 'Table:replaceTable') {
      const { newTableName } = payload;

      $pool.push('Table:replaceTable::idle', () => {
        convertUnits(currentUnits, payload.tables[newTableName]);
      });

      return;
    }

    if (eventName === 'Row:changeMode') {
      const { Controller } = payload;

      $pool.push('Table:changeMode::mutate', () => {
        Controller.cells.forEach(cell => {
          convertUnits(currentUnits, cell);
        });
      });
    }
  };
}

export default SwitchUnitsPlugin;
